"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var View = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  align-items: stretch;\n  border: 0 solid black;\n  box-sizing: border-box;\n  display: flex;\n  flex-basis: ", " !important;\n  flex-shrink: 0 !important;\n  flex-direction: column;\n  margin: 0;\n  min-height: 0;\n  min-width: 0;\n  padding: 0;\n  position: relative;\n  z-index: 0;\n"])), function () {
  return 'auto';
});
var _default = exports["default"] = View;